import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://passswords.visssible.com/backend';

const handleResponse = (response) => {
  const { success, data, message } = response.data;

  if (!success) {
    throw new Error(message || 'Request failed');
  }

  return data;
};

const handleRequest = async (request) => {
  try {
    const response = await request();
    return handleResponse(response);
  } catch (error) {
    const message = error.response?.data?.message;
    throw new Error(message || error.message || 'Request failed');
  }
};

export const fetchCards = async () => {
  return handleRequest(() => axios.get(`${API_BASE_URL}/cards-list.php`));
};

export const createCard = async (payload) => {
  return handleRequest(() => axios.post(`${API_BASE_URL}/cards-insert.php`, payload));
};

export const updateCard = async (id, payload) => {
  return handleRequest(() =>
    axios.post(`${API_BASE_URL}/cards-update.php`, {
      id,
      ...payload,
    })
  );
};

export const deleteCard = async (id) => {
  return handleRequest(() => axios.post(`${API_BASE_URL}/cards-delete.php`, { id }));
};
